module.exports = __webpack_public_path__ + "img/wave2.bee25d4.webp";